import { useMediaQuery as useMantineMediaQuery } from "@mantine/hooks";

/**
 * Whether the media query matches, updated when it changes. The app's only media query hook: it reads the query
 * right away (the app isn't server-rendered), so the first render already lays out for the screen it's on.
 * Mantine's and usehooks-ts' hooks differ in that (Mantine's reads it after the first render by default).
 */
export const useMediaQuery = (query: string) =>
  useMantineMediaQuery(query, undefined, { getInitialValueInEffect: false });
